import AsyncStorage from '@react-native-async-storage/async-storage';
import { CALC_ROUTE_SET, CalcCategory, findCalc } from './calcRegistry';

export type FavoriteEntry = {
  category: CalcCategory;
  route: string;
  title: string;
  /** Unix ms when pinned */
  ts: number;
};

const KEY = 'tabai.favorites.v1';
const MAX = 12;

export async function loadFavorites(): Promise<FavoriteEntry[]> {
  try {
    const raw = await AsyncStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (x) =>
        x &&
        typeof x.route === 'string' &&
        CALC_ROUTE_SET.has(x.route) &&
        typeof x.category === 'string',
    );
  } catch (e) {
    console.warn('[favorites] loadFavorites failed:', e);
    return [];
  }
}

async function save(entries: FavoriteEntry[]): Promise<void> {
  try {
    await AsyncStorage.setItem(KEY, JSON.stringify(entries.slice(0, MAX)));
  } catch (e) {
    console.warn('[favorites] save failed:', e);
  }
}

export async function isFavorite(route: string): Promise<boolean> {
  const list = await loadFavorites();
  return list.some((f) => f.route === route);
}

export async function addFavorite(route: string): Promise<void> {
  const calc = findCalc(route);
  if (!calc) return;
  const existing = await loadFavorites();
  if (existing.some((f) => f.route === route)) return;
  const next: FavoriteEntry[] = [
    { category: calc.category, route: calc.route, title: calc.title, ts: Date.now() },
    ...existing,
  ].slice(0, MAX);
  await save(next);
}

export async function removeFavorite(route: string): Promise<void> {
  const existing = await loadFavorites();
  await save(existing.filter((f) => f.route !== route));
}

export async function toggleFavorite(route: string): Promise<boolean> {
  if (await isFavorite(route)) {
    await removeFavorite(route);
    return false;
  }
  await addFavorite(route);
  return true;
}
